import { AnswerModel } from './answer.model';

export class TaskModel
{
	id: number = undefined;
	name: string = undefined;
	done: boolean = undefined;
}